<div class="floatLabel inputPrincipal" [ngClass]="{'soloLectura' : disabled}">

     <!-- Input -->
     <input id="input{{id}}" [(ngModel)]="valor"  
       [ngClass]="{'is-filled': (input.value || input.value === 0), 'inputDeshabilitado' : disabled}" 
       #input="ngModel"
       type="{{type}}" 
       class="form-control"  
       required 
       [pattern]="pattern" 
       [textMask]="{mask: mask, guide:false}" 
       [maxLength]="maxLength" 
       (keypress)="TeclaPrecionada($event)">

       <!-- Título -->
       <label>{{titulo}}</label>

    <!-- Button limpiar --->
    <button *ngIf="(input.value || input.value === 0) && !disabled" (click)="LimpiarValor()"
        class="btnTimes" tabindex="-1">
        <span class="fa fa-times"></span>
    </button>

    <!-- Mensaje de error -->
    <span [hidden]="!verError || input.valid || (!input.touched && !errorActivo)"
        class="textoError" >
        {{mensajeError ? (mensajeError | translate) : ('DatoIncompeto' | translate)}}
</span>

</div>
